import { lazy } from 'react';

export const LazyViewGalleryTemplatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--view-gallery-template-page" */ './view-gallery-template-page'
    ),
);
